const url = '/countries';
const Provider = 'Countries';
const dbModel = 'Countries';

export { url, Provider, dbModel };
